import ProgressIndicator from './ProgressIndicator';

export default ProgressIndicator;
